import { Redirect, useParams } from 'react-router-dom';
import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import moment from 'moment';
import { ACTIVITY_TYPE } from '../../../constants';
import LandingPage from '../index';
import BookedAppointment from '../BookedAppointment';
import { ROUTE_PREFIX_BOOKING, ROUTES } from '../../../constants/routes';
import { isAppointmentBooked } from '../../../utils/bookingUtils';
import { getLoadedWorkflow } from '../../../slices/workflow';

const { CANCEL, POSTPONE, CONFIRM } = ACTIVITY_TYPE;
const CLOSED_ACTIVITIES = [CANCEL, CONFIRM];

const LandingPageWrapper = () => {
  const { workflowId } = useParams();
  const workflow = useSelector(({ workflow }) =>
    getLoadedWorkflow(workflow, workflowId)
  );
  const activities = get(workflow, 'activities', []);
  const latestActivity = [...activities].pop();

  // A booked appointment is shown as it is, rather than the booking options.
  if (isAppointmentBooked(workflow)) {
    return <BookedAppointment />;
  }

  if (latestActivity) {
    const { name, postponeWeeks, createTime } = latestActivity;
    const postponeDate =
      name === POSTPONE &&
      moment(createTime).clone().add(postponeWeeks, 'weeks');
    if (
      CLOSED_ACTIVITIES.includes(name) ||
      (postponeDate && moment().isBefore(postponeDate))
    ) {
      return (
        <Redirect
          to={`${ROUTE_PREFIX_BOOKING}/${workflowId}${ROUTES.NOTIFICATION}?type=${name}`}
        />
      );
    }
  }

  return <LandingPage />;
};

export default LandingPageWrapper;
